h1 {
  margin-top: 1rem;
  font-size: calc(100dvw / 12);
  font-weight: 300;
  text-align: center;
  width: 100%;
  max-width: 64rem;

  strong {
    font-weight: 500;
  }

  @media (min-width: 48rem) {
    margin-top: 2.5rem;
    font-size: calc(100dvw / 15);
  }

  @media (min-width: 64rem) {
    text-align: left;
    font-size: 4.4rem;
  }
}

.ctaNav {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
  @media (min-width: 48rem) {
    gap: 1.75rem;
  }

  @media (min-width: 64rem) {
    justify-content: left;
  }
}

.primaryLink,
.secondaryLink {
  border-radius: 2rem;
  padding: 1rem 2.4rem;
  text-decoration: none;
  gap: 0.5rem;
  margin: 0 1rem;
  width: 100%;
  justify-content: center;
  @media (min-width: 32rem) {
    margin: 0;
    width: auto;
  }

  svg {
    height: 1lh;
    path {
      fill: currentColor;
    }
  }
}

.primaryLink {
  background: linear-gradient(
    to top,
    var(--color-red-light),
    var(--color-red-dark)
  );
  color: #fff;
  font-size: 1.5rem;
  font-weight: 500;
  text-align: center;
  @media (min-width: 32rem) {
    margin: 0;
    width: auto;
  }
}

.secondaryLink {
  display: inline-flex;
  color: var(--color-foreground);
  border: 1px solid currentColor;
  font-size: 1rem;
  font-weight: 300;
  justify-content: center;
  align-items: center;
}

.underlineBlue {
  text-decoration: 3px underline var(--color-blue-dark);
  text-underline-offset: 0.09lh;
  text-decoration-skip-ink: none;
}

.stars {
  transition: --stars 0.8s ease;
  counter-reset: stars var(--stars);
  font-variant-numeric: tabular-nums;
  &::after {
    content: " " counter(stars) " ⭐️";
  }
}
